import React from "react";
import careerImg from "../../../assets/Images/career/c_1.JPG";

const Career_Banner = () => {
  return (
    <section className="relative w-full h-[300px] md:h-[500px] overflow-hidden">
      
      {/* Background Image */}
      <img
        src={careerImg}
        alt="Career"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 flex flex-col justify-end">
        
        {/* Title */}
        <h1 className="text-white text-2xl md:text-4xl font-semibold">
          Careers
        </h1>

        {/* Description */}
        <p className="text-gray-200 text-sm md:text-base mt-2 mb-6 max-w-xl leading-relaxed">
          Join our team and build a rewarding career with opportunities to grow.
        </p>

      </div>
    </section>
  );
};

export default Career_Banner;